import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1546.99289 L1920,1653.65896 L533.341037,1653.65896 L533.341037,1546.99289 L1920,1546.99289 Z M357.651346,442.668357 L662.076322,746.986667 L357.651346,1051.30498 L282.345098,975.998728 L457.917456,800.319704 L106.666074,800.319704 L106.666074,1653.6483 L0,1653.6483 L0,693.65363 L457.917456,693.65363 L282.345098,518.081272 L357.651346,442.668357 Z M1920,1120.22193 L1920,1226.99467 L533.341037,1226.99467 L533.341037,1120.22193 L1920,1120.22193 Z M1066.67141,693.664296 L1066.67141,800.33037 L853.339259,800.33037 L853.339259,693.664296 L1066.67141,693.664296 Z M1493.3357,693.664296 L1493.3357,800.33037 L1280.00356,800.33037 L1280.00356,693.664296 L1493.3357,693.664296 Z M1920,693.664296 L1920,800.33037 L1706.66785,800.33037 L1706.66785,693.664296 L1920,693.664296 Z M1920,267 L1920,373.666074 L533.341037,373.666074 L533.341037,267 L1920,267 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveUpLine, _Component);

  var _super = _createSuper(IconMoveUpLine);

  function IconMoveUpLine() {
    _classCallCheck(this, IconMoveUpLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveUpLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUp",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpLine.displayName = "IconMoveUpLine";
  return IconMoveUpLine;
}(Component);

IconMoveUpLine.glyphName = 'move-up';
IconMoveUpLine.variant = 'Line';
IconMoveUpLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpLine;
export { IconMoveUpLine };